import { COMPLETED_ORDER_STATUS } from "../../../utils/orderCompletion";

const toOrderDate = (value) => {
  if (!value) return null;
  const date = typeof value.toDate === "function"
    ? value.toDate()
    : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatPatientOrderCompletion = (order) => {
  if (!order || order.status !== COMPLETED_ORDER_STATUS) return "-";
  const date = toOrderDate(order.completedAt) || toOrderDate(order.receiptDate);
  return date
    ? formatPatientOrderDate(date)
    : "Date unavailable";
};

export const formatPatientOrderDate = (value) => {
  const date = toOrderDate(value);
  return date ? date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "Asia/Bangkok",
  }) : "-";
};

// Patient logs mirror only the first CPAP. Full orders also contain accessories
// and purchases imported without a patient log. Merge by document ID, not receipt
// number: separate orders can legitimately share the same receipt number.
export const mergePatientPurchaseOrders = (patientOrders, legacyOrders, saleOrders) => {
  const orders = new Map();
  [patientOrders, legacyOrders, saleOrders].forEach((source) => {
    source.forEach((order) => {
      orders.set(order.id, { ...orders.get(order.id), ...order });
    });
  });
  return Array.from(orders.values())
    .filter((order) => order.status !== "ยกเลิก" &&
      (!order.activity || order.activity === "purchase"))
    .sort((left, right) => {
      const leftDate = toOrderDate(left.createdAt) || toOrderDate(left.receiptDate);
      const rightDate = toOrderDate(right.createdAt) || toOrderDate(right.receiptDate);
      return (rightDate ? rightDate.getTime() : 0) - (leftDate ? leftDate.getTime() : 0);
    });
};

export const getPatientOrderItems = (order) => {
  if (Array.isArray(order.items)) return order.items.filter(Boolean);

  // Preserve older purchases saved before sales orders used an items array.
  const items = [];
  if (order.productId || order.productSn) {
    items.push({
      productId: order.productId,
      productSn: order.productSn,
      deviceNo: order.deviceNo,
      productType: "CPAP",
    });
  }
  if (order.mask) {
    items.push({ productName: order.mask, size: order.maskSize, productType: "Mask", itemType: "Accessory" });
  }
  if (typeof order.accessories === "string" && order.accessories.trim()) {
    items.push({ productName: order.accessories, productType: "Other", itemType: "Accessory" });
  }
  return items;
};
